import { Box, Typography, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import professionalLinkBlocked from "../../../../../assets/images/SVG/professionalLinkBlocked.svg";
import RoundedButton from "../../../../../components/Buttons/RoundedButton/RoundedButton";

const ProfessionalBlockedView = ({ redirectToDashboard, redirectToAccountSettings }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%"
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "#662D91",
          textAlign: "center",
          fontWeight: 700,
          fontStyle: "normal",
          fontFamily: "Montserrat, sans-serif",
          fontSize: "1.125rem",
          lineHeight: "1.339rem",
          letterSpacing: "0%",
          mb: 2
        }}
      >
        {t("inviteUsers.professional_blocked_title")}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          fontStyle: "normal",
          fontSize: "0.938rem",
          lineHeight: "0.969rem",
          letterSpacing: "0%",
          textAlign: "center",
          color: "#4d4d4d",
          mb: 3,
          maxWidth: 480
        }}
      >
        {t("inviteUsers.professional_blocked_description")}
      </Typography>

      <Box
        sx={{
          my: 3,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={professionalLinkBlocked}
          alt={t("inviteUsers.professional_blocked_img_alt")}
        />
      </Box>

      <Stack
        direction={{
          xs: "column",
          sm: "row"
        }}
        spacing={2}
        sx={{
          mt: 2,
          width: "100%",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <RoundedButton
          onClick={redirectToAccountSettings}
          text={t("inviteUsers.not_a_professional")}
          sx={{
            background: "transparent",
            color: "#662D91",
            border: "2px solid #662D91",
            minWidth: 200,
            borderRadius: "20px",
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontSize: "0.938rem",
            lineHeight: "1.054rem",
            textTransform: "uppercase",
            boxShadow: "none",
            "&:hover": { background: "rgba(102,45,145,0.05)", boxShadow: "none" },
          }}
        />
        <RoundedButton
          onClick={redirectToDashboard}
          text={t("inviteUsers.return_to_dashboard")}
          sx={{
            background: "transparent",
            color: "#662D91",
            border: "2px solid #662D91",
            minWidth: 200,
            borderRadius: "20px",
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            fontSize: "0.938rem",
            lineHeight: "1.054rem",
            textTransform: "uppercase",
            boxShadow: "none",
            "&:hover": { background: "rgba(102,45,145,0.05)", boxShadow: "none" },
          }}
        />
      </Stack>
    </Box>
  );
};

export default ProfessionalBlockedView;
